import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const StickyMobileCTA = () => {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-foreground/95 backdrop-blur-md border-t border-border/20 px-4 py-3 safe-bottom">
      <Button variant="hero" size="lg" className="w-full group" asChild>
        <a href="/booking">
          Book Your Discovery Call
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
      </Button>
    </div>
  );
};

export default StickyMobileCTA;
